//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DirectionsSelect from '../../../landing_generator/components/sobre/directionsSelect';

export default {
  name: 'Direction',
  components: {
    DirectionsSelect,
  },
  props: ['currentDirection', 'directions', 'loading', 'filter', 'applyFilter'],
  computed: {
    computedDirections() {
      return this.directions.map((direction) => ({
        ...direction,
        name: this.$t(direction.name),
      }));
    },
  },
};
